import React from 'react';
import ReactDOM from 'react-dom';
import defaultUserThumb from '../../lib/images/user-thumb-default.png'
import moment from 'moment/min/moment-with-locales';
import CommentCard from './CommentCard'
import jump from 'jump.js'
import Modal from '../App/Modal'

moment.locale('ja')

export default class Component extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      menuOpen: false,
      editMode: false,
      postContent: this.props.post ? this.props.post.content : "",
      "comment[content]": "",
      commentMode: false,
      commentShow: false,
      openModal: false
    }
  }

  nl2br = (text) => {
    var regex = /(\r\n|\n|\r)/gm
    return text.split(regex).map(function (line) {
      if (line.match(regex)) {
        return React.createElement('br')
      }
      else {
        return line;
      }
    });
  }

  deleteModalOpen = () => {
    this.setState({ openModal: true })
  }

  deleteModalCancel = () => {
    this.setState({ openModal: false })
  }

  deleteConfirm = () => {
    const html = window.document.documentElement;
    html.classList.remove('slideout-open')
    // this.setState({ openModal: false, menuOpen: false})
    
    this.props.destroyPost(this.props.post.id, this.props.circle.id)
  }

  componentWillUnmount = () => {
    const header = document.getElementById('appHeader')
    if (header.classList.contains('fadeout')) {
      header.classList.remove('fadeout')
    }
    if (header.classList.contains('panel-open')) {
      header.classList.remove('panel-open')
    }
    header.classList.add('fadein')
  }

  valueChange = (e) => {
    // console.log('change', e.target.name, e.target.value)
    this.setState({
      [e.target.name]: e.target.value
    })
  }


  toggleMenu = (elm) => {
    const html = window.document.documentElement;
    const mainObject = document.getElementById('panel')
    // const windowHeight = window.innerHeight;
    // console.log('toggleMenu', windowHeight, mainScrollHeight, targetTop, scrollDiff)

    if (this.state.menuOpen) {
      html.classList.remove('slideout-open')
      this.deleteNextOrPrevClass()
      mainObject.style.height = 'auto'
      jump(-50, {
        duration: 200,
        callback: () => {
          
        }
      })
      this.setState({ menuOpen: false, editMode: false })
    } else {
      

      // ウインドウサイズ
      const windowHeight = document.documentElement.clientHeight;
      // mainタグの高さ
      const mainScrollHeight = mainObject.scrollHeight
      // ターゲット
      const targetCard = elm.target.parentNode.parentNode
      // ターゲットの相対的位置
      const targetOffsetTop = targetCard.offsetTop
      const HeaderHeight = document.querySelector('.circleHeader').scrollHeight
      const inputHeight = document.querySelector('.postCreateFieldWrap').scrollHeight
      // ターゲットの絶対位置
      const targetTop = targetOffsetTop + HeaderHeight + inputHeight
      const targetHeight = targetCard.clientHeight
      const targetBottomPosition = targetTop + targetHeight
      const targetBottomBlankHeight = mainScrollHeight - targetBottomPosition
      const needBlankHeight = windowHeight - targetHeight
      const canScroll = needBlankHeight <= targetBottomBlankHeight

      if (!canScroll) {
        mainObject.style.height = `${mainScrollHeight + (needBlankHeight - targetBottomBlankHeight + 50)}px`

      } else {
        mainObject.style.height = 'auto'
      }

      jump(elm.target.parentNode.parentNode, {
        duration: 200,
        offset: 0, 
        callback: () => {
          // html.classList.add('slideout-open')
        }
      })
      this.setState({ menuOpen: true })
    }
  }

  deleteNextOrPrevClass = () => {
    const nextCard = document.getElementsByClassName('nextCard')
    const beforeCard = document.getElementsByClassName('previousCard')

    if (nextCard) {
      [].forEach.call(nextCard, (elm) => {
        elm.classList.remove('nextCard')
        elm.style.marginTop = '15px'
      })
    }
    if (beforeCard) {
      [].forEach.call(beforeCard, (elm) => {
        elm.style.marginBottom = 'auto'
        elm.classList.remove('previousCard')
      })
    }
  }

  componentDidUpdate = () => {

    const targetCard = document.querySelector('.postCard.menuOpen')
    const header = document.getElementById('appHeader')
    if (targetCard) {
      const cardHeight = targetCard.offsetHeight

      const nextCard = targetCard.nextElementSibling
      const beforeCard = targetCard.previousElementSibling
      let heightMargin

      if (!!beforeCard && beforeCard.classList.contains("postCard")) {
        heightMargin = 30
      } else {
        heightMargin = 15
      }

      const blankHeight = cardHeight + heightMargin

      if (nextCard) {
        nextCard.style.marginTop = `${blankHeight}px`
        nextCard.classList.add('nextCard')
      } else {
        
        // if (beforeCard) {
        //   beforeCard.style.marginBottom = `${blankHeight}px`
        //   beforeCard.classList.add('previousCard')
        // }
      }

      header.classList.add('panel-open')
      if (header.classList.contains('fadein')) {
        header.classList.remove('fadein')
      }
      header.classList.add('fadeout')

    } else {
      
      this.deleteNextOrPrevClass()

      header.classList.remove('panel-open')

      if (header.classList.contains('fadeout')) {
        header.classList.remove('fadeout')
      }
      header.classList.add('fadein')
    }
    

    const editField = document.querySelector('.post-edit-input')
    if (editField) {
      editField.focus()
    }

  }

  editPost = () => {
    // const input = document.querySelector('[data-post-id="' + this.props.post.id + '"]')
    this.setState({ editMode: true })
  }

  onCommentSubmit = () => {
    const content = this.state["comment[content]"]
    this.setState({ "comment[content]": '' }, this.props.commentCreate(content, this.props.post.id, this.props.circle.id))
    
  }

  cancelEditPost = () => {
    this.setState({ editMode: false })
  }

  commentInputFocus = () => {
    this.setState({
      editMode: false,
      commentMode: true
    })
  }

  commentInputBlur = () => {
    this.setState({
      commentMode: false
    })
  }

  commentsShow = () => {
    this.setState({ commentShow: true })
  }
  
  commentsHide = () => {
    jump("#postCard"+this.props.post.id, {
      duration: 200,
      offset: -50
    })
    this.setState({ commentShow: false })
  }

  updatePost = () => {
    this.toggleMenu()
    this.props.updatePost(this.state.postContent ,this.props.post.id, this.props.circle.id)
  }

  render = () => {
    const post = this.props.post
    const circle = this.props.circle
    const currentUser = this.props.currentUser
    const user = post.user
    let format
    const today = new Date()
    const todayYear = today.getFullYear()
    const postAt = new Date(post.created_at)
    const postYear = postAt.getFullYear()
    if (todayYear !== postYear) {
      format = "YYYY年M月D日 H:mm"
    } else {
      format = "M月D日 H:mm"
    }
    const isMyPost = !!currentUser && currentUser.id === user.id

    let menu, overlay, menuContent, comments, modal

    if (this.state.openModal) {
      modal = (
        <Modal
          okClickHandler={this.deleteConfirm}
          headerTitle='投稿の削除'
          isOpen={this.state.openModal}
          closeModal={this.deleteModalCancel}
          okText='削除する'
        >
          <p>投稿を削除します。<br />本当によろしいですか？</p>
        </Modal>
      )
    }

    if (this.state.menuOpen && isMyPost) {

      if (this.state.editMode) {
        menuContent = (
          <ul className='postMenu fadein'>
            <li className='box-shadow btn btn-primary' onClick={this.updatePost}><span>上記内容で更新</span></li>
            <li className='box-shadow btn btn-white' onClick={this.cancelEditPost}><span>編集をやめる</span></li>
          </ul>
        )
      } else {
        menuContent = (
          <ul className='postMenu fadein'>
            <li className='box-shadow btn btn-primary' onClick={this.editPost}><span>編集</span></li>
            <li className='box-shadow btn btn-danger' onClick={this.deleteModalOpen}><span>削除</span></li>            <li className='box-shadow btn btn-white' onClick={this.toggleMenu}><span>閉じる</span></li>
            {/* <li><span onClick={this.deletePost}>削除</span></li> */}
          </ul>
        )
      }

      menu = (
          <div className='postEditMenu'>
            {menuContent}
          </div>
      )
      overlay = (
        <div id='menuOverlay' onClick={this.toggleMenu} className='fadein' ></div>
      )
    }

    if (post.comments.length > 0) {
      // コメントがある場合
      if (this.state.commentShow && !this.state.menuOpen) {
        comments = (
          <div className='text-left commentsList'>
            <div className='blankDiv'></div>
            {(() => {
              return (
                post.comments.sort((a, b) => {
                  const aDate = new Date(a.created_at)
                  const bDate = new Date(b.created_at)
                  const aNum = Math.round(aDate.getTime() / 1000)
                  const bNum = Math.round(bDate.getTime() / 1000)
                  if (aNum < bNum) return -1;
                  if (aNum > bNum) return 1;
                  return 0;
                }).map(comment => {
                  return (
                    <CommentCard comment={comment} currentUser={currentUser} updateComment={this.props.commentUpdate} destroyComment={this.props.commentDestroy} post={post} circle={circle} />
                  )
                })
              )
            })()}
            <div className='text-right' style={{marginTop: '10px' }}>
              <a onClick={this.commentsHide} className='commentHide' >コメントを隠す</a>
            </div>
          </div>
          
        )
      } else {
        comments = (
          <a className='commentsShow' onClick={this.commentsShow}>{post.comments.length}件のコメント...</a>
        )
      }
    }

    return (
      // <div className='postCardWrap'>
        <div className={'postCard row' + ((this.state.menuOpen && isMyPost) ? ' menuOpen' : '') + ((this.state.commentMode) ? ' commentMode' : '')} id={'postCard'+post.id}>
          {ReactDOM.createPortal(modal, document.getElementById('dialogSpace'))}
          {(() => {
            if (this.state.menuOpen && isMyPost) {
              return (
                <div>
                  {ReactDOM.createPortal(menu, document.getElementById('menuBottomWrap'))}
                  {ReactDOM.createPortal(overlay, document.getElementById('contentOverlayWrap'))}
                </div>
              )
            }
          })()
          }
          <div className='col-12 clearfix postMetaInfo'>
            <div className='userThumb float-left' style={{ backgroundImage: `url(${user.photo || defaultUserThumb})` }}></div>
            <p className='userName text-left'>
              {user.name}
              <br />
              <span className='postAt'>{moment(post.created_at).format(format)}</span>
            </p>
            {(() => {
              if (isMyPost) {
                return (
                  <i className={"material-icons postMenuToggle" + (this.state.menuOpen ? ' active' : '')} onClick={this.toggleMenu} >more_horiz</i>
                )
              }
            })()}
          </div>
          <div className='col-12 postContentWrap'>
            <div className='postContent'>
              {(() => {
                if (this.state.editMode) {
                  return (
                    <textarea type="text" name="postContent" className='post-edit-input' value={this.state.postContent} onChange={this.valueChange}
                     />
                  )
                } else {
                  return (
                    <p className="postBody">{this.nl2br(post.content)}</p>
                  )
                }
              })()}
            </div>
        </div>
        <div className='commentsWrap col-12'>
          {comments}
          <div id={'commentMenuWrap' + post.id}></div>
        </div>
        
          {(() => {
            if (!this.state.menuOpen && this.props.joined) {
              return (
                <div className='col-12 commentAreaWrap'>
                  <div className='userThumb commentOwnThumb' style={{backgroundImage: `url(${currentUser.photo || defaultUserThumb})`}}></div>
                  <form className="comment-form" data-post-id={post.id}>
                    <textarea type="text" name='comment[content]' className="commentInput" value={this.state["comment[content]"]} onChange={this.valueChange} placeholder='コメントする...' onBlur={this.commentInputBlur} onFocus={this.commentInputFocus} />
                    {(() => {
                      if (this.state.commentMode) {
                        return (
                          <input type='submit' value='送信' className='btn btn-xs btn-submit' onMouseDown={this.onCommentSubmit} />
                        )
                      }
                    })()}
                  </form>
                </div>
              )
            }
          })()}

        </div>
      // </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/Post/Card.jsx